module.exports = __webpack_public_path__ + "img/type-07.f157196a.jpg";